var map = {
	"./Jugend_Werntalcup_2023.jpg": 306,
	"./Rueckblick1.jpg": 533,
	"./Rueckblick2.jpg": 952,
	"./Rueckblick3.jpg": 410,
	"./Rueckblick4.jpg": 368,
	"./RückblickTTLangendorf.jpg": 588,
	"./Spielstandam07102023.jpg": 152,
	"./TTBLKönigshofen 25112023.jpg": 824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 867;